import config from '@/config';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/RemovePicturePopup.css';

/** This component receives the handler for removing the data 
 * (each component is responsible for giving this one the correct way to remove the picture)
 */
export default function RemovePicturePopup({ open, close, pictureData, removePicture }) {
  return (
    <GenericPopup 
      open={open} 
      opacity 
      className="add-artwork-remove-picture-popup" 
      backgroundClassName="add-artwork-remove-picture-popup-background"
    >

      <Text className="add-artwork-remove-picture-popup_header_text" medium paragraph >
        Do you want to delete this image?

        {/* Added close icon at the top */}
        <XIcon
          className="add-artwork-remove-picture-popup_close"
          onClick={close}
        />
      </Text>

      <div className="add-artwork-remove-picture-popup__picture-details-container">
        <img 
          src={`${config.app.imageServiceDomain}/${pictureData?.image_id}/w=200`} 
          alt="artwork pic to remove" 
          className="add-artwork-remove-picture-popup__picture-details-picture" 
        />
        <Text className="add-artwork-remove-picture-popup__picture-details-picture-name" medium paragraph>
          {pictureData?.image_original_data.name}
        </Text>
      </div>

      <div className="add-artwork-remove-picture-popup__actions">
        <ContinueButton 
          onClick={close} 
          medium 
          className="continue-button_two"
        >
          Keep it
        </ContinueButton>

        <ContinueButton 
          onClick={removePicture} 
          medium 
          className="continue-button_two"
        >
          Yes, delete
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
